import { render, staticRenderFns } from "./classical-information.vue?vue&type=template&id=a53e326a"
import script from "./classical-information.vue?vue&type=script&lang=js"
export * from "./classical-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports